import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectInfraredImagesAndUploadsByFlightId } from "features/entity-caching/images/hotspots/selectors"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { InspectorPanelAccordionIntegrations } from "../accordion/integrations/InspectorPanelAccordionIntegrations"
import { useDownloadButtonData } from "plugins/InfraredImage/useInfraredImageDownloadButtonData"
import { openHotspotPanel, setHotspotPanelState, toggleList } from "panels/hotspot/slice"
import { selectInfraredFlightById } from "features/entity-caching/flights/selectors"

const emptyUploads = [] as never[]

export const InspectorPanelHotspotData = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const flight = useAppSelector(selectInfraredFlightById(id))
    const uploads = useAppSelector(selectInfraredImagesAndUploadsByFlightId(id))
    const completedUploadCount = flight.images.length
    const downloadOptions = useDownloadButtonData(uploads || emptyUploads)

    const showImages = () => {
        dispatch(setHotspotPanelState({ flightId: id, imageId: uploads?.at(0)?.id }))
        dispatch(openHotspotPanel())
        dispatch(toggleList())
    }

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            {/* Integrations */}
            <InspectorPanelAccordionIntegrations
                id={id}
                integrationOptions={downloadOptions.integrationOptions}
            />

            <InspectorPanelMetadata
                entity={flight as SidePanelLayer}
                uploads={uploads as GenericUpload[]}
                completedUploadCount={completedUploadCount}
                onShowImagesClick={showImages}
            />
        </div>
    )
}
